import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabFonte = '/service/contabilidade/transparencia/'
const urlTabFonteFontes = 'service/portal/conteudo/transparencia/'

class FonteService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getFonte() {
        let data = {
            identificacaoFonte: 'CNMP_fonte_informacao_receita_propria',
        }

        return this.conex.post(urlTabFonte + 'fonteInformacao/', JSON.stringify(data))
    }

    getFonteMat(base, identificacao) {
        let data = {
            baseUrl: base,
            identificacaoFonte: identificacao,
        }

        return this.conex.post(urlTabFonteFontes + 'fonteInformacaoMat/', JSON.stringify(data))
    }
}

export default FonteService
